import { AnalyticsContext } from '@carvana/eventable-clickstream';
import Content from '@carvana/seo-contentmod';
import { useContext } from 'react';

function ContentMods({ mods }) {
  const { trackEvent } = useContext(AnalyticsContext);

  return mods?.contentMod ? (
    <Content
      contentMods={mods}
      assetsUrl={`${process.env.CVNA_APP_ASSETS_CDN}`}
      trackEvent={trackEvent}
    />
  ) : null;
}

export default ContentMods;
